import { Input, Component, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import { AuthenticationService } from "../../shared/authentication.service";
import { LicenseService } from "../../shared/licens.service";
import { BoughtItem, ShoppingCart } from '../../models/PaymentData';
import { environment } from '../../../environments/environment';
import { LicenseData } from "../../models/LicenseData";
import { ApiService } from '../../shared/api.service';

@Component({
  selector: "vc-poll-overview-header",
  templateUrl: "poll-overview-header.component.html",
  styleUrls: ["./poll-overview-header.component.less", '../../shared/common.less'],
})

export class PollOverviewHeader implements OnInit {
  @Input() title: string;
  @Input() shouldReturnToPoll = false;
  @Input() pollId: string;
  @Input() isLive: boolean;
  @Input() isPublic: string;
  @Input() SMSOption: boolean;
  @Input() is2FA: boolean;
  @Input() isAssessors = false;
  @Input() opened: boolean = false;
  @Input() image: string = '';
  @Input() suspended: boolean = false;
  maxVoters = 10;
  shoulDisplayChangePopup: boolean;
  smsAdditionalOption: boolean;
  licencesReady: boolean = false;
  isAssoc: boolean;
  licenseTime: string;
  hasHotline: boolean;
  clientType = 'assoc';
  eventCounter = 0;
  accountName: string = "";
  hotlinePopup: boolean;
  stripeConstants = environment.stripeConstants;
  stripe: stripe.Stripe;
  selectedOffer: number;
  shouldBuyCredits: boolean = false;
  moreOption: boolean = false;
  getContacted: boolean = false;
  isPayment: boolean = false;
  confirmContact: boolean = false;

  constructor(
    private auth: AuthenticationService,
    private router: Router,
    private authenticationService: AuthenticationService,
    public licenseService: LicenseService,
    private apiService: ApiService
  ) { }

  getContactPhone($event: string) {
    const mailData = this.licenseService.getContactMailObject(this.selectedOffer, this.accountName, this.isAssoc, $event);
    this.auth.sendContactMail(mailData).subscribe((res) => {
      this.confirmContact = true;
      this.getContacted = false;
    });
  }

  newPoll() {
    this.router.navigate(['/poll-creation']);
  }


  openOffers($event) {
    if ($event) {
      this.getContacted = true;
    }
    else {
      this.shouldBuyCredits = true;
    }
    this.moreOption = false;
  }

  dismissPayPopup($event) {
    this.shouldBuyCredits = false;
  }

  displayMoreInfo($event) {
    this.moreOption = true;
    this.selectedOffer = $event[0];
    this.isAssoc = $event[1] == 1;
  }

  navigateHome() {
    this.router.navigate(["/polls"]);
  }

  navigateArrow() {
    this.shouldReturnToPoll ? this.router.navigate(["/poll-ongoing/" + this.pollId]) : this.router.navigate(["/polls"]);
  }

  ngOnChanges(): void {
  }

  ngOnInit(): void {
    this.licenseService.license.subscribe((res: LicenseData) => {
      this.licencesReady = true;

      this.hasHotline = res.hasHotline;
      this.maxVoters = res.votes;
      this.eventCounter = res.events;
      if (res.client !== null) { this.isAssoc = (res.client !== 'corp'); }
      this.clientType = res.client;
      switch (res.duration) {
        case "Y": {
          this.licenseTime = "Y";
          break;
        }
        case "DM": {
          this.licenseTime = "DM";
          break;
        }
        default:
          this.licenseTime = "D";
      }
      this.accountName = this.authenticationService.getUserData();
    });
    this.stripe = Stripe(this.stripeConstants.key);
  }

  logout() {
    this.authenticationService.logout();
    this.router.navigate(['/connexion']);
  }

  changeSubscription() {
    this.shoulDisplayChangePopup = true;
    this.smsAdditionalOption = true;
  }

  triggerHotlinePopup() {
    this.hotlinePopup = true;
  }

  dismissInitialPopup() {
    this.confirmContact = false;
    this.getContacted = false;
    this.hotlinePopup = false;
    this.dismissChangePopup()
  }

  setHotlineOption($event) {
    switch ($event) {
      case 0: {
        const hotlineCode: string = this.isAssoc ? this.stripeConstants.hotline.assoc.oneEvent : this.stripeConstants.hotline.corp.oneEvent;
        this.buyHotline(hotlineCode);
        break;
      }
      case 1: {
        const hotlineCode = this.isAssoc ? this.stripeConstants.hotline.assoc.fiveEvents : this.stripeConstants.hotline.corp.fiveEvents;
        this.buyHotline(hotlineCode);
        break;
      }
      case 2: {
        const hotlineCode = this.isAssoc ? this.stripeConstants.hotline.assoc.anual : this.stripeConstants.hotline.corp.anual;
        this.buyHotline(hotlineCode);
        break;
      }
    }
  }

  buyHotline(transactionID: string) {
    const items = [new BoughtItem(transactionID, 1)];
    const cart = new ShoppingCart(
      items,
      this.stripeConstants.tax20,
      null
    );

    this.apiService.createCheckoutSessionDashboard(cart).subscribe((res) => {
      const sessionKey = 'sessionId';
      this.stripe
        .redirectToCheckout({ sessionId: res[sessionKey] })
        .then((result) => {
          console.log(result);
        });
    });
  }

  dismissChangePopup() {
    this.hotlinePopup = false;
    this.shoulDisplayChangePopup = false;
    this.smsAdditionalOption = false;
  }

  setSMSOption($event) {
    switch ($event) {
      case 0: {
        this.selectOffer(this.selectedOffer);
        break;
      }
      case 1: {
        const smsCode = this.isAssoc !== false ? this.stripeConstants.sms.assoc.pack200 : this.stripeConstants.sms.corp.pack200;
        this.selectOffer(this.selectedOffer, smsCode);
        break;
      }
      case 2: {
        const smsCode = this.isAssoc !== false ? this.stripeConstants.sms.assoc.pack500 : this.stripeConstants.sms.corp.pack500;
        this.selectOffer(this.selectedOffer, smsCode);
        break;
      }
      case 3: {
        const smsCode = this.isAssoc !== false ? this.stripeConstants.sms.assoc.pack1000 : this.stripeConstants.sms.corp.pack1000;
        this.selectOffer(this.selectedOffer, smsCode);
        break;
      }
      case 4: {
        const smsCode = this.isAssoc !== false ? this.stripeConstants.sms.assoc.pack5000 : this.stripeConstants.sms.corp.pack5000;
        this.selectOffer(this.selectedOffer, smsCode);
        break;
      }
    }
  }

  selectOffer(index: number, smsOption: string = '') {
    switch (index) {
      case 1: {
        const price = this.stripeConstants.event.association;
        this.createCart(price, smsOption);
        break;
      }
      case 2: {
        const price = this.stripeConstants.pack.association;
        this.createCart(price, smsOption);
        break;
      }
      case 3: {
        const price = this.stripeConstants.year.association;
        this.createCart(price, smsOption);
        break;
      }
      default: {
        this.createCart('', smsOption);
      }
    }
  }

  createCart(offer: string, smsCode: string = '') {
    const items = offer.length > 0 ? [new BoughtItem(offer, 1)] : [];
    if (smsCode.length > 0) { items.push(new BoughtItem(smsCode, 1)); }
    if (items.length > 0) {
      const cart = new ShoppingCart(
        items,
        this.stripeConstants.tax20,
        null
      );
      this.buyOffer(cart);
    } else { this.dismissChangePopup(); }
  }

  buyOffer($event) {
    this.apiService.createCheckoutSessionDashboard($event).subscribe((res) => {
      const sessionKey = 'sessionId';
      this.stripe
        .redirectToCheckout({ sessionId: res[sessionKey] })
        .then((result) => {
          console.log(result);
        });
    });
  }

}
